var __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

define('views/navigation/GuideView',['require','underscore','evertrue','reactDOM','ET/ETView','modules/layout/guide-modules','modules/layout/guide'],function(require) {
  var ETView, EverTrue, Guide, GuideModules, GuideView, ReactDOM, _;
  _ = require("underscore");
  EverTrue = require("evertrue");
  ReactDOM = require("reactDOM");
  ETView = require("ET/ETView");
  GuideModules = require("modules/layout/guide-modules");
  Guide = require("modules/layout/guide");
  return GuideView = (function(_super) {
    __extends(GuideView, _super);

    function GuideView() {
      return GuideView.__super__.constructor.apply(this, arguments);
    }

    GuideView.prototype.className = "guide";

    GuideView.prototype.initialize = function() {
      return EverTrue.vent.on("navChange", this.render, this);
    };

    GuideView.prototype.getGuideData = function() {
      var collection, moduleId;
      moduleId = this.getModuleId();
      collection = GuideModules.getModules();
      return _.findWhere(collection, {
        id: moduleId
      });
    };

    GuideView.prototype.getModuleId = function() {
      var urlParts;
      urlParts = Backbone.history.fragment.split("/");
      return this.override() || urlParts.pop();
    };

    GuideView.prototype.moduleOverrides = function() {
      return {
        "requests": "dashboard/requests",
        "users": "dashboard/users",
        "flex": "data/flex/*",
        "contacts": "person/manage/*",
        "search": "person/manage/search",
        "importer": "data/importer",
        "resources": "dashboard/growth/resources"
      };
    };

    GuideView.prototype.override = function() {
      var match, url;
      url = Backbone.history.fragment;
      match = false;
      _.each(this.moduleOverrides(), function(val, key) {
        if (url.match(val)) {
          return match = key;
        }
      });
      return match;
    };

    GuideView.prototype.render = function() {
      var data;
      data = this.getGuideData();
      if (data) {
        return ReactDOM.render(Guide({
          data: data
        }), document.getElementById("guide"));
      }
    };

    return GuideView;

  })(ETView);
});

//# sourceMappingURL=GuideView.js.map
;
